import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import AIAssistantWidget from './AIAssistantWidget';
import { ADMIN_PANEL_PATH, ADMIN_ROLE_MANAGER_PATH } from '../config/adminRoutes';

/** Routes où le FAB d’aide ne doit pas apparaître (écrans concentrés / outils). */
const HIDDEN_PREFIXES = [
  ADMIN_PANEL_PATH,
  ADMIN_ROLE_MANAGER_PATH,
  '/login',
  '/signup',
  '/register',
  '/complete-profile',
  '/reset-password',
  '/verify-email',
  '/devenir-agent',
  '/dashboard-agent',
  '/dashboard-activity-tickets',
];

function shouldHideAssistant(pathname) {
  if (!pathname) return false;
  return HIDDEN_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

/**
 * Nimba — aide FAQ discrète (pas un widget « IA » omniprésent).
 * Masqué sur admin / auth / onboarding agent.
 */
const AIAssistant = () => {
  const location = useLocation();
  const hidden = useMemo(
    () => shouldHideAssistant(location.pathname),
    [location.pathname]
  );

  if (hidden) return null;
  return <AIAssistantWidget />;
};

export default AIAssistant;
